import React, { useEffect, useState } from 'react'; 
import styles from './../../Assets/CSS/Listing.module.css';
import modalStyles from './../../Assets/CSS/Modal.module.css'; 
import inputStyles from './../../Assets/CSS/Input.module.css';  
import { IoIosArrowForward } from 'react-icons/io';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { IoIosStar, IoIosStarOutline } from 'react-icons/io';
import dummyImg from './../../Assets/Images/image-dummy.png'; 
import { FaCheckCircle, FaEnvelope, FaFacebook, FaGlobe, FaInstagram, FaPhone, FaWhatsapp } from 'react-icons/fa';
import { IoLocationOutline } from 'react-icons/io5';
import { ImStatsDots } from 'react-icons/im';
import { GreenButton, BlueButton } from '../../Components/Button';
import { BiSolidPhoneCall } from 'react-icons/bi'; 
import { FaCircleCheck } from 'react-icons/fa6';
import { AiOutlineMail } from 'react-icons/ai';
import { SlGlobe } from 'react-icons/sl';
import { MdClose, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
     
function Listing() { 
    const navigate = useNavigate();
    const current_location = useLocation();  
    const { u_id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [listing_id, setListingId] = useState([]);
    const [listing, setListing] = useState([]);
    const [total_rating, setTotalRating] = useState([]);
    const [tabIndex, setTabIndex] = useState(0); 
    const accessToken = localStorage.getItem('accessToken'); 
    const [details, setDetails] = useState([]);
    const location = localStorage.getItem('location');  
    const [ads, setAds] = useState([]);
    
    // Organized ads by position for Inner page
    const [topAds, setTopAds] = useState([]);
    const [bottomAds, setBottomAds] = useState([]);
    const [leftAds, setLeftAds] = useState([]);
    const [centerAds, setCenterAds] = useState([]);
    const [rightAds, setRightAds] = useState([]);
    
    // Current index for rotation
    const [topIndex, setTopIndex] = useState(0);
    const [bottomIndex, setBottomIndex] = useState(0);
    const [leftIndex, setLeftIndex] = useState(0);
    const [centerIndex, setCenterIndex] = useState(0);
    const [rightIndex, setRightIndex] = useState(0);
    
    // Image viewer states
    const [showImageViewer, setShowImageViewer] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    
    function onGetDetails() {
        setIsLoading(true);
        axios.get(`${BASE_URL}/listing-detail/${u_id}`, {
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            document.title = `Infomart | ${res.data.data.name}`; 
            setListingId(res.data.data.id); 
            const averageRating = res.data.data.review && res.data.data.review.length > 0 ? res.data.data.review.reduce((acc, review) => acc + review.rating, 0) / res.data.data.review.length : 0;
            setTotalRating(Math.round(averageRating));
            setListing(res.data.data);
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        }); 
    } 
    
    useEffect(() => {
        onGetDetails(); 
        axios.get(`${BASE_URL}/ads`, {
            headers: {  
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            const allAds = res.data.data;
            setAds(allAds);
            
            // Filter ads by position for Inner page
            const innerAds = allAds.filter(ad => ad.page === 'Inner');
            
            setTopAds(innerAds.filter(ad => ad.position === 'Top'));
            setBottomAds(innerAds.filter(ad => ad.position === 'Bottom'));
            setLeftAds(innerAds.filter(ad => ad.position === 'Left'));
            setCenterAds(innerAds.filter(ad => ad.position === 'Center'));
            setRightAds(innerAds.filter(ad => ad.position === 'Right'));
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
        });     
        if (accessToken) {
            axios.get(`${BASE_URL}/user/details`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setDetails(res.data.data); 
            }).catch((res) => {
                // Handle error
            });  
        }
    }, [u_id]);
    
    // Auto rotate ads every 4 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            if (rightAds.length > 1) {
                setRightIndex((prev) => (prev + 1) % rightAds.length);
            }
            // Add rotation for other positions if needed
        }, 4000);
        
        return () => clearInterval(interval);
    }, [rightAds]);
    
    const [enquiry, setEnquiry] = useState(false);  
    const handleEnquiry = () => { 
        if (accessToken) { 
            setEnquiry(true);   
        } else {  
            localStorage.setItem('currentLocation', current_location.pathname);    
            navigate('/user/login'); 
        }  
    }  
    
    const handleCall = (phone) => { 
        if (accessToken) {  
            window.location.href = `tel:${phone}`; 
        } else {   
            localStorage.setItem('currentLocation', current_location.pathname);    
            navigate('/user/login'); 
        }   
    }   
    
    const handleWhatsapp = (no) => { 
        if (accessToken) {   
            window.open(`https://wa.me/${no}`, '_blank');  
        } else {   
            localStorage.setItem('currentLocation', current_location.pathname);    
            navigate('/user/login'); 
        }   
    }   
    
    const onClose = () => {
        setEnquiry(false); 
    }  
    
    // Image viewer functions
    const openImageViewer = (index) => {
        setSelectedImageIndex(index);
        setShowImageViewer(true);
        document.body.style.overflow = 'hidden'; // Prevent body scroll
    };
    
    const closeImageViewer = () => {
        setShowImageViewer(false);
        document.body.style.overflow = 'auto'; // Restore body scroll
    };
    
    const goToPreviousImage = () => {
        setSelectedImageIndex((prevIndex) => 
            prevIndex === 0 ? (listing.image?.length - 1) : prevIndex - 1
        );
    };
    
    const goToNextImage = () => {
        setSelectedImageIndex((prevIndex) => 
            prevIndex === (listing.image?.length - 1) ? 0 : prevIndex + 1
        );
    };
    
    // Handle keyboard navigation
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (showImageViewer) {
                if (e.key === 'ArrowLeft') goToPreviousImage();
                if (e.key === 'ArrowRight') goToNextImage();
                if (e.key === 'Escape') closeImageViewer();
            }
        };
        
        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [showImageViewer, listing.image]);
    
    const [isEnquiryLoading, setIsEnquiryLoading] = useState(false);  
    const [subject, setSubject] = useState('');  
    const [message, setMessage] = useState('');  
    
    const handleSendEnquiry = async () => {
        setIsEnquiryLoading(true); 
        await axios.post(`${BASE_URL}/user/listing/enquiry`, {listing_id, subject, message}, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }   
        }).then((res) => { 
            setEnquiry(false); 
            setSubject(''); 
            setMessage('');  
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsEnquiryLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsEnquiryLoading(false);
        });    
    } 
    
    function timeAgo(reviewDate) {
        const now = new Date();
        const past = new Date(reviewDate);
        let diff = now - past;
        const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
        diff -= years * (1000 * 60 * 60 * 24 * 365);
        const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
        diff -= months * (1000 * 60 * 60 * 24 * 30);
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff -= days * (1000 * 60 * 60 * 24);
        const hours = Math.floor(diff / (1000 * 60 * 60));
        diff -= hours * (1000 * 60 * 60);
        const minutes = Math.floor(diff / (1000 * 60));
        const time = `${years !== 0 ? years + " years" : ""} ${months !== 0 ? months + " months" : ""} ${years === 0 && months === 0 && days !== 0 ? days + " days" : ""} ${years === 0 && months === 0 && days === 0 && hours !== 0 ? hours + " hours" : ""} ${years === 0 && months === 0 && days === 0 && hours === 0 && minutes !== 0 ? minutes + " minutes" : ""}`; 
        const timeago = years === 0 && months === 0 && days === 0 && hours === 0 && minutes === 0 ? 'Just now' : `${time} ago`;  
        return timeago; 
    }   
    
    const [rating, setRating] = useState(5); 
    const handleStarClick = (index) => {
        setRating(index + 1); 
    };  
    
    const [isReviewLoading, setIsReviewLoading] = useState(false);   
    const [review, setReview] = useState('');    
    
    const handleReviewPost = async () => {
        if (accessToken) { 
            axios.get(`${BASE_URL}/user/details`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setDetails(res.data.data); 
                setIsReviewLoading(true); 
                axios.post(`${BASE_URL}/user/listing/review`, {listing_id, rating, review}, {
                    headers: {  
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`
                    }    
                }).then((res) => {   
                    setReview('');    
                    onGetDetails(); 
                    toast.success(res.data.msg, { autoClose: 3000 });
                    setIsReviewLoading(false);
                }).catch((res) => {
                    toast.error(res.response.data.msg, { autoClose: 3000 });
                    setIsReviewLoading(false);
                }); 
            }).catch((res) => {
                if (res.response.status === 401) {
                    ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
                    navigate('/user/login');  
                } else { 
                    toast.error(res.response.data.msg, { autoClose: 3000 }); 
                }  
            });    
        } else {  
            localStorage.setItem('currentLocation', current_location.pathname);    
            navigate('/user/login'); 
        }   
    }
    
    return (
        <div className="app"> 
            {/* Image Viewer Modal */}
            {showImageViewer && listing.image?.length > 0 && (
                <div className={styles.imageViewerOverlay} onClick={closeImageViewer}>
                    <div className={styles.imageViewerContainer} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeButton} onClick={closeImageViewer}>
                            <MdClose size={30} />
                        </button>
                        
                        {listing.image?.length > 1 && (
                            <>
                                <button className={styles.navButton + ' ' + styles.prevButton} onClick={goToPreviousImage}>
                                    <MdKeyboardArrowLeft size={40} />
                                </button>
                                <button className={styles.navButton + ' ' + styles.nextButton} onClick={goToNextImage}>
                                    <MdKeyboardArrowRight size={40} />
                                </button>
                            </>
                        )}
                        
                        <img 
                            src={BASE_FILE_URL + listing.image[selectedImageIndex]?.image} 
                            alt={`Listing image ${selectedImageIndex + 1}`}
                            className={styles.viewerImage}
                        />
                        
                        <div className={styles.imageCounter}>
                            {selectedImageIndex + 1} / {listing.image?.length}
                        </div>
                        
                        {/* Thumbnail strip */}
                        <div className={styles.thumbnailStrip}>
                            {listing.image?.map((img, index) => (
                                <img
                                    key={index}
                                    src={BASE_FILE_URL + img.image}
                                    alt={`Thumbnail ${index + 1}`}
                                    className={`${styles.thumbnail} ${index === selectedImageIndex ? styles.activeThumbnail : ''}`}
                                    onClick={() => setSelectedImageIndex(index)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
            
            {enquiry ? 
                <div className={modalStyles.enquiryModalContainer}> 
                    <div className={modalStyles.closeBtn} onClick={onClose}>&times;</div>
                    <div className={modalStyles.innerEnquiryContainer}> 
                        <div className={modalStyles.form}> 
                            <h4 className="mb-2">Enquire Now</h4>
                            <div className={modalStyles.col}>
                                <h6 className="mb-0">Subject</h6>
                                <input type="text" className={inputStyles.input} value={subject} placeholder="Enter enquiry subject" onChange={e => setSubject(e.target.value)} />
                            </div>  
                            <div className={modalStyles.col}>
                                <h6 className="mb-0">Message</h6>
                                <textarea className={inputStyles.textarea} value={message} placeholder="Enter your enquiry here.." onChange={e => setMessage(e.target.value)} />
                            </div>   
                            <BlueButton title={isEnquiryLoading ? "Loading..." : "Send Enquiry"} onClick={() => handleSendEnquiry()} />
                        </div>     
                        <div className={modalStyles.description}>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Your requirement is sent to the selected relevant businesses</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Businesses compete with each other to get you the Best Deal</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">You choose whichever suits you best</span>
                            </div>
                            <div className={modalStyles.row}>
                                <div className={modalStyles.dot}></div>
                                <span className="text-muted w-100">Contact info sent to you by SMS/Email</span>
                            </div>
                        </div>
                    </div> 
                </div>
            : null }   
            <div className="outlet">
                <div className={styles.mainWrapper}>
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className={styles.engineersDetailsPageContainer}>
                            <div className="mb-4"><span>{location} <IoIosArrowForward /></span><span className="ms-1">{listing.sub_category?.name} in {location} <IoIosArrowForward /></span> {listing.sub_sub_category?.name}</div>
                            <div className={styles.topSection}> 
                                <div className={styles.imgSection}>
                                    <div className={styles.mainImgContainer} onClick={() => openImageViewer(0)} style={{ cursor: 'pointer' }}>
                                        <img src={listing.image && Array.isArray(listing.image) && listing.image[0]?.image ? BASE_FILE_URL + listing.image[0].image : dummyImg} className={styles.mainImg} />
                                    </div>
                                    <div className={styles.subImgContainer}>
                                        {listing.image?.map((data, i) => (
                                            <img 
                                                src={BASE_FILE_URL + data.image} 
                                                className={styles.subImg} 
                                                key={i} 
                                                onClick={() => openImageViewer(i)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ))}
                                    </div> 
                                </div>
                                <div className={styles.detailsSection}>
                                    <div className={styles.leftSection}>
                                        <h1 className="my-3">{listing.name}</h1>
                                        <div className={`${styles.companyName} my-2`}>
                                            <span className={styles.stars}>
                                                {[0, 1, 2, 3, 4].map((item, index) => (
                                                    index < total_rating ? <IoIosStar color="#0673A8" key={index} /> : <IoIosStarOutline color="#0673A8" key={index} />
                                                ))}   
                                            </span> 
                                            <span className="mx-2">{listing.review?.length} Reviews</span>
                                            <div><FaCheckCircle size={18} color="green" /> Verified</div>
                                        </div> 
                                        <div className={`${styles.row} mt-2`}>
                                            <IoLocationOutline size={24} color="black" />
                                            <span>{listing.house_no}, {listing.road_name}, {listing.district}, {listing.state}, {listing.pincode}</span>
                                            <div className={styles.dot}></div> 
                                            <h6 className={`${styles.greenTxt} mb-0`}>Active</h6> 
                                        </div>  
                                        <div className={`${styles.row} mt-2 mb-3`}>
                                            <ImStatsDots /> 
                                            <span>{listing.enquiry?.length ?? 0} people recently enquired</span>
                                        </div>   
                                        <GreenButton leftIcon={<BiSolidPhoneCall />} title="Call Now" onClick={() => handleCall(listing.phone)} /> 
                                    </div>  
                                    <div className={styles.rightSection}>
                                        <div className={styles.buttons}> 
                                            <button className={styles.grayBtn}>{listing.sub_sub_category?.name}</button> 
                                        </div> 
                                        <button className={styles.blueBtn} onClick={handleEnquiry}>Enquire Now</button>
                                    </div>      
                                </div>  
                                <div className={styles.bottomSection}>
                                    <div className={styles.leftSection}>
                                        <div className="my-5">
                                            <h3 className="mt-3">Description</h3>
                                            <div className="text-muted mt-3"> 
                                                {listing.description} 
                                            </div> 
                                        </div> 
                                        <div className={styles.tabSection}>
                                            <div className={styles.tabBarContainer}>
                                                <h3 className={`${styles.tabHead} ${tabIndex === 0 ? styles.active : ""}`} onClick={() => setTabIndex(0)}>Quick Information</h3> 
                                                <h3 className={`${styles.tabHead} ${tabIndex === 1 ? styles.active : ""}`} onClick={() => setTabIndex(1)}>Photos</h3>
                                                <h3 className={`${styles.tabHead} ${tabIndex === 2 ? styles.active : ""}`} onClick={() => setTabIndex(2)}>Highlight</h3>
                                            </div>     
                                            <div className={styles.tabContent}>
                                                {tabIndex === 0 ?
                                                    <div className={styles.tabContentInner}>
                                                        <div className={styles.row}>
                                                            <IoLocationOutline size={20} />
                                                            <span>{listing.house_no}, {listing.road_name}, {listing.district}, {listing.state}, {listing.pincode}</span>
                                                        </div>  
                                                        <div className={styles.row}>
                                                            <FaEnvelope size={20} />
                                                            <a href={`mailto:${listing.email}`} className="text-decoration-none">  
                                                                <span>{listing.email}</span> 
                                                            </a>
                                                        </div> 
                                                        <div className={styles.row} style={{ cursor: 'pointer' }}>
                                                            <FaPhone size={20} /> 
                                                            <span onClick={() => handleCall(listing.phone)}>Call Now</span>
                                                        </div> 
                                                        <div className={styles.row} style={{ cursor: 'pointer' }}> 
                                                            <FaWhatsapp size={20} />
                                                            <span onClick={() => handleWhatsapp(listing.whatsapp)}>WhatsApp</span>
                                                        </div>   
                                                        {listing.website && (
                                                            <div className={styles.row}>
                                                                <FaGlobe size={20} />
                                                                <a href={listing.website} target="_blank" className="text-decoration-none"> 
                                                                    <span>{listing.website}</span>
                                                                </a>
                                                            </div> 
                                                        )} 
                                                        {listing.facebook && (
                                                            <div className={styles.row}>
                                                                <FaFacebook size={20} />
                                                                <a href={listing.facebook} target="_blank" className="text-decoration-none"> 
                                                                    <span>{listing.facebook}</span>
                                                                </a>
                                                            </div> 
                                                        )} 
                                                        {listing.instagram && ( 
                                                            <div className={styles.row}>
                                                                <FaInstagram size={20} />
                                                                <a href={listing.instagram} target="_blank" className="text-decoration-none">  
                                                                    <span>{listing.instagram}</span>
                                                                </a>
                                                            </div>  
                                                        )}  
                                                    </div> 
                                                : tabIndex === 1 ?
                                                    <div className={styles.tabContentInner}>
                                                        {listing.image?.map((data, i) => (
                                                            <img 
                                                                src={BASE_FILE_URL + data.image} 
                                                                className={styles.tabImges} 
                                                                key={i} 
                                                                onClick={() => openImageViewer(i)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        ))}   
                                                    </div>
                                                : 
                                                    <div className={styles.tabContentInnerPhotos}>
                                                        <div className={styles.row}>
                                                            <FaCircleCheck color="green" />
                                                            <h4 className="mt-1">{listing.highlight}</h4>
                                                        </div>  
                                                    </div>   
                                                }
                                            </div> 
                                        </div>  
                                    </div>
                                    <div className={styles.reviewSection}>
                                        <h2>Reviews</h2> 
                                        {listing.review?.length > 0 ? 
                                            listing.review?.map((data, i) => ( 
                                                <div className={styles.reviewCard} key={i}>
                                                    <div className={styles.row}>
                                                        <div className={styles.userImgContainer}>
                                                            <img src={data.user?.image ? BASE_FILE_URL + data.user?.image : dummyImg} className={styles.userImg} />
                                                        </div>   
                                                        <div>
                                                            <h5 className="my-1">{data.user?.name}</h5>
                                                            <div>{timeAgo(data.created_at)}</div>
                                                        </div>  
                                                    </div> 
                                                    <div>
                                                        <span className={styles.stars}>
                                                            {[0, 1, 2, 3, 4].map((item, i) => (
                                                                <IoIosStar key={i} size={24} color={i < data.rating ? "#ffea1d" : "#dddddd"} />
                                                            ))} 
                                                        </span>
                                                    </div> 
                                                    <div>{data.review}</div>  
                                                </div> 
                                            ))
                                        :
                                            <div>No review available.</div>
                                        } 
                                    </div> 
                                    <div className={styles.writeReviewSection}>
                                        <h2>Write a Review</h2>
                                        <div className={styles.spaceRow}>
                                            <div className={styles.row}>
                                                <div>
                                                    <div className={styles.userImgContainer}>
                                                        <img src={details.image ? BASE_FILE_URL + details.image : dummyImg} className={styles.userImg} />
                                                    </div> 
                                                </div>
                                                <div>
                                                    {details.name ?
                                                        <h5 className="my-1">{details.name}</h5> 
                                                    :
                                                        <h5 className="my-1">Guest</h5> 
                                                    } 
                                                    <div>Your opinion matters</div>
                                                </div> 
                                            </div>
                                            <span className={styles.stars}>
                                                {[0, 1, 2, 3, 4].map((item, i) => (
                                                    <IoIosStar key={i} size={28} color={i < rating ? "#0673A8" : "#d3d3d3"} onClick={() => handleStarClick(i)} />
                                                ))}   
                                            </span>
                                        </div>
                                        <textarea name="review" className={inputStyles.textarea} placeholder="Write Your Review" onChange={e => setReview(e.target.value)} />
                                        <BlueButton title={isReviewLoading ? "Loading..." : "Submit"} onClick={() => handleReviewPost()} />   
                                    </div>  
                                    <div className={styles.rightSection}>
                                        <div className={styles.contactSection}>
                                            <div className={`${styles.row} ${styles.contactItem}`}>
                                                <FaWhatsapp color="green" size={30} /> 
                                                <h6 className="my-0"><a href={'https://wa.me/+91' + listing.whatsapp} className="text-decoration-none" target="_blank">Chat via Whatsapp</a></h6>
                                            </div>  
                                            <div className={`${styles.row} ${styles.contactItem}`}>
                                                <AiOutlineMail />
                                                <h6 className="my-0"><a href={'mailto:' + listing.email} className="text-decoration-none">SMS/Email</a></h6>
                                            </div> 
                                            <div className={`${styles.row} ${styles.contactItem}`}>
                                                <SlGlobe /> 
                                                <h6 className="my-0"><a href={listing.website} className="text-decoration-none" target="_blank">Visit Our Website</a></h6>
                                            </div>
                                            <div className={`${styles.row} ${styles.contactItem}`}>
                                                <FaFacebook /> 
                                                <h6 className="my-0"><a href={listing.facebook} className="text-decoration-none" target="_blank">Facebook</a></h6>
                                            </div>
                                            <div className={`${styles.row} ${styles.contactItem}`}>
                                                <FaInstagram />
                                                <h6 className="my-0"><a href={listing.instagram} className="text-decoration-none" target="_blank">Instagram</a></h6>
                                            </div>    
                                        </div>
                                        <div className={styles.featuredAd}> 
                                            <div className={`${styles.spaceRow} my-2`}>
                                                <h6>Featured Ads</h6>
                                            </div>
                                            {/* Position-based ads for Inner page */}
                                            {rightAds.length > 0 ? (
                                                <img src={BASE_FILE_URL + rightAds[rightIndex]?.image} className={styles.adImg} />
                                            ) : (
                                                ads[0] && <img src={BASE_FILE_URL + ads[0]?.image} className={styles.adImg} />
                                            )}
                                        </div>
                                        {/* Additional ads - can be other positions or fallback */}
                                        {rightAds.length > 1 && rightAds[1] ? (
                                            <img src={BASE_FILE_URL + rightAds[(rightIndex + 1) % rightAds.length]?.image} />
                                        ) : (
                                            ads[1] && <img src={BASE_FILE_URL + ads[1]?.image} />
                                        )}
                                        {rightAds.length > 2 && rightAds[2] ? (
                                            <img src={BASE_FILE_URL + rightAds[(rightIndex + 2) % rightAds.length]?.image} />
                                        ) : (
                                            ads[2] && <img src={BASE_FILE_URL + ads[2]?.image} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div> 
                    }
                </div>
            </div> 
        </div>
    );
}

export default Listing; 